export function isHttpError(error: unknown): boolean {
  return !!(error && typeof error === 'object' && (error as { constructor?: { name?: string } }).constructor?.name === 'HttpErrorResponse');
}

export function getSanitizedUrl(): string {
  return `${globalThis.location.origin}${globalThis.location.pathname}`;
}
